import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import { Ripple } from "primereact/ripple";
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';
import { Role } from "../../../Controllers/Types/ContactResponse";
import { contactDeleteAPI, employeeCompanyUpdateAPI, roleCreateAPI, roleDataGetAPI, subContactDataAPI, subContactDeleteAPI, subContactUpdateAPI } from "../../../Api/ContactApi";
import { checkEmail, checkFileImage, checkMobileNumber, checkPhoneNumber, checkRole, checkText } from "../../../Utils/Validator";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { SubContact } from "../../../Controllers/Types/ProfessionalInterface";
import { fetchAllContactAfterEditProfessionalDetails } from "../../../Controllers/Thunks/contactThunks";
import { useAuth } from "../../../Authentication/AuthContext";
import { imageFileExtension } from "../../../Api/FileConstant";
import { goToTop } from "../../../Components/goToTop";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import ErrorPage from "../../../Components/ErrorPage";
import CompanySearchDialog from "../CompanySearchDialog";
import { CompanyInterface } from "../../../Controllers/Types/CompanyType";
import EmailSearchDialog from "../EmailSearchDialog";

const ViewCompanyEmployeeContact: React.FC = () => {

    const professional = useAppSelector(state => state.contact.selectedProfessional);
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const [tab, setTab] = useState<'company' | 'contact' | 'sub_contact'>('company');
    const [dataState, setDataState] = useState<string>('Create');
    const [loading, setLoading] = useState<boolean>(false);
    const [showAddData, setShowAddData] = useState<boolean>(false);

    const [showSubContactModal, setShowSubContactModal] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    /******************************** Company form variables  ********************************/
    const [companyName, setCompanyName] = useState<string>('');
    const [companyRegNo, setCompanyRegNo] = useState<string>('');
    const [companyEmail, setCompanyEmail] = useState<string>('');
    const [companyMobile, setCompanyMobile] = useState<string>('');
    const [companyLandline, setCompanyLandline] = useState<string>('');
    const [companyAddress, setCompanyAddress] = useState<string>('');
    const [companyCity, setCompanyCity] = useState<string>('');
    const [companyPostCode, setCompanyPostCode] = useState<string>('');

    /* Company error massage */
    const [errorCompanyName, setErrorCompanyName] = useState<string>('');
    const [errorCompanyRegNo, setErrorCompanyRegNo] = useState<string>('');
    const [errorCompanyEmail, setErrorCompanyEmail] = useState<string>('');
    const [errorCompanyMobile, setErrorCompanyMobile] = useState<string>('');
    const [errorCompanyLandline, setErrorCompanyLandline] = useState<string>('');
    const [errorCompanyAddress, setErrorCompanyAddress] = useState<string>('');
    const [errorCompanyCity, setErrorCompanyCity] = useState<string>('');
    const [errorCompanyPostCode, setErrorCompanyPostCode] = useState<string>('');
    /**********************************************************************************************/

    /********************************  Contact form variables  ********************************/
    const [profileImage, setProfileImage] = useState<string | null>();
    const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [primaryPhone, setPrimaryPhone] = useState<string>('');
    const [secondaryPhone, setSecondaryPhone] = useState<string>('');

    /* contact error massage */
    const [errorProfileImageFile, setErrorProfileImageFile] = useState<string>('');
    const [errorFirstName, setErrorFirstName] = useState<string>('');
    const [errorLastName, setErrorLastName] = useState<string>('');
    const [errorEmail, setErrorEmail] = useState<string>('');
    const [errorPrimaryPhone, setErrorPrimaryPhone] = useState<string>('');
    const [errorSecondaryPhone, setErrorSecondaryPhone] = useState<string>('');

    /* **************************  Role form variables *************************/
    //Role list 
    const [roleList, setRoleList] = useState<Role[]>([]);

    const [role, setRole] = useState<Role>({ id: 0, role_name: '' });
    const [roleName, setRoleName] = useState<string>('');
    const [displayRoleName, setDisplayRoleName] = useState<string>('');

    const [errorRoleId, setErrorRoleId] = useState<string>('');
    const [errorRoleName, setErrorRoleName] = useState<string>('');
    const [errorDisplayRoleName, setErrorDisplayRoleName] = useState<string>('');
    /* **************************  Role form variables *************************/


    /* ************************************* contact show ******************************** */
    const [editContactDetailId, setEditContactDetailId] = useState<number>(0);
    const [mainContact, setMainContact] = useState<SubContact | null>(null);
    const [subContactList, setSubContactList] = useState<SubContact[] | null>(null);
    const [showOneSubContact, setShowOneSubContact] = useState<SubContact | null>(null);
    const [contentLoading, setContentLoading] = useState<boolean>(false);

    const [isMainDefaultProfileImage, setIsMainDefaultProfileImage] = useState<boolean>(false);
    const [isSubDefaultProfileImage, setIsSubDefaultProfileImage] = useState<boolean>(false);

    const [showSearchCompanyDetailsModal, setShowSearchCompanyDetailsModal] = useState<boolean>(false);
    const [showSearchComEmpEmailModal, setShowSearchComEmpEmailModal] = useState<boolean>(false);
    const [showSearchSubContractComEmpEmailModal, setShowSearchSubContractComEmpEmailModal] = useState<boolean>(false);


    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionAdd = useCanEdit('Contact', 'add')
    const isPermissionUpdate = useCanEdit('Contact', 'update')
    const isPermissionDelete = useCanEdit('Contact', 'delete')

    //For image upload/change
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setProfileImage(event.target.result);

                    const file = e.target.files?.[0];
                    setProfileImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    // 

    // For clear image
    const clearImage = () => {
        setProfileImage(null);
        setProfileImageFile(null);
    };

    /* ************** API Error massage show ****************** */
    function showAPIErrorComapanyData(keyName: string, error: string): void {

        if (keyName === "regno") {
            setErrorCompanyRegNo(error);
        }
        if (keyName === "email") {
            setErrorCompanyEmail(error);
        }
        if (keyName === "phone") {
            setErrorCompanyMobile(error);
        }
        if (keyName === "landline") {
            setErrorCompanyLandline(error);
        }
    }

    function showAPIErrorSubContact(keyName: string, error: string): void {

        if (keyName === "email") {
            setErrorEmail(error);
        }
        if (keyName === "pimary_phone_no") {
            setErrorPrimaryPhone(error);
        }
        if (keyName === "secondary_phone_no") {
            setErrorSecondaryPhone(error);
        }
        if (keyName === "profile_image") {
            setErrorProfileImageFile(error);
        }

    }
    /* ************** API Error massage show ****************** */

    /* **************************** clear All error massage *************************** */
    const clearAllErrorMassage = () => {

        setErrorCompanyName('');
        setErrorCompanyRegNo('');
        setErrorCompanyEmail('');
        setErrorCompanyMobile('');
        setErrorCompanyLandline('');
        setErrorCompanyAddress('');
        setErrorCompanyCity('');
        setErrorCompanyPostCode('');


        setErrorRoleId('');
        setErrorDisplayRoleName('');


        setErrorProfileImageFile('');
        setErrorFirstName('');
        setErrorLastName('');
        setErrorEmail('');
        setErrorPrimaryPhone('');
        setErrorSecondaryPhone('');

    };
    /* **************************** clear All error massage *************************** */


    /* **************************** ********************* Contact update - start *********************************************** */
    /* main contect */
    const mainContactEdit = () => {
        setShowEditModal(true);

        if (mainContact) {
            contactUpdateDataSet(mainContact);
        }
    }
    /* sub contect */
    const handleEditSubContact = (subContact: SubContact) => {
        setDataState('Edit');
        setShowSubContactModal(true);

        contactUpdateDataSet(subContact);
    };

    /* clear conact inupt field */
    const clearContactInput = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setPrimaryPhone('');
        setSecondaryPhone('');
        setRole({ id: 0, role_name: '' });
        setDisplayRoleName('');
        setProfileImage('');
        setEditContactDetailId(0);
    }

    /* contact update data set */
    function contactUpdateDataSet(conactData: SubContact) {

        clearContactInput();

        setProfileImage(conactData.profile_image);
        setFirstName(conactData.first_name);
        setLastName(conactData.last_name);
        setEmail(conactData.email);
        setPrimaryPhone(conactData.pimary_phone_no);
        setSecondaryPhone(conactData.secondary_phone_no);
        setRole({ id: conactData.user_role_id, role_name: conactData.role_name });
        setDisplayRoleName(conactData.display_role_name);
        setEditContactDetailId(conactData.id);

    }


    function checkCredentialsContactData(): boolean {
        const isFirstNameValid = checkText(firstName, true, setErrorFirstName);
        const isLastNameValid = checkText(lastName, true, setErrorLastName);
        const isEmailValid = checkEmail(email, true, setErrorEmail);
        const isPrimaryPhoneValid = checkPhoneNumber(primaryPhone, true, setErrorPrimaryPhone);
        const isSecondaryPhoneValid = checkPhoneNumber(secondaryPhone, false, setErrorSecondaryPhone);
        const isRoleValid = checkRole(role, true, setErrorRoleId);
        const isDisplayRoleNameValid = checkText(displayRoleName, true, setErrorDisplayRoleName);
        const isFileValid = checkFileImage(profileImageFile!, false, setErrorProfileImageFile);

        return isFirstNameValid && isLastNameValid && isEmailValid && isSecondaryPhoneValid && isPrimaryPhoneValid && isRoleValid && isDisplayRoleNameValid && isFileValid;
    }

    /* main contact edit */
    const handleUpdateMainContact = async (e: React.FormEvent) => {
        e.preventDefault();

        if (mainContact) {
            const responce = await updateProfessionalContactData(mainContact?.id, mainContact?.employee_type);

            if (responce) {

                dispatch(fetchAllContactAfterEditProfessionalDetails());
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Main contact details updated successfully.',
                        life: 3000
                    });
                }

                setShowEditModal(false);
                clearImage();
                goToTop();
            }
        }
    }

    /* sub contact edit */
    const handleUpdateSubContact = async (e: React.FormEvent) => {
        e.preventDefault();

        if (editContactDetailId !== 0) {
            const responce = await updateProfessionalContactData(editContactDetailId, "Sub Employee");

            if (responce) {

                dispatch(fetchAllContactAfterEditProfessionalDetails());
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Sub contact details updated successfully.',
                        life: 3000
                    });
                }

                setShowSubContactModal(false);
                goToTop();

                clearImage();
            }
        }
    };

    /* contact edit - API call function */
    const updateProfessionalContactData = async (contactId: number, employeeType: string) => {

        clearAllErrorMassage();

        if (checkCredentialsContactData()) {
            setLoading(true);
            const data = await subContactUpdateAPI(contactId, employeeType, firstName, lastName, email, primaryPhone, secondaryPhone, Number(role.id), displayRoleName, profileImageFile!);
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorSubContact(key, value[0])
                    ))
                }

                return false;
            } else {
                clearAllErrorMassage();

                return true;
            }
        } else {
            return false;
        }
    }

    /* **************************************************** Sub contact ******************************************************************* */
    const handleSetSubcontactData = async (oneSubContact: SubContact) => {
        setContentLoading(true);
        setShowOneSubContact(oneSubContact);

        setTimeout(() => {
            setContentLoading(false);
        }, 1000);
    };

    /* **************************************************** Sub contact - delete ******************************************************************* */
    const handleDeleteSubContact = (subContactId: number): void => {

        confirmDialog({
            message: 'Are you sure you want to delete the selected sub employee details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteSubContact(subContactId),
        });
    };

    const deleteSubContact = async (subContactId: number) => {

        const data = await subContactDeleteAPI(subContactId);

        if (data.status) {
            dispatch(fetchAllContactAfterEditProfessionalDetails());

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Sub contact delete successfully.',
                    life: 3000
                });
            }
            goToTop();
        }

    }
    /* **************************************************** Sub contact - delete ******************************************************************* */

    /* *********************************************  For new Sub Contact create - start  ************************************************************ */
    const addSubContact = async (e: React.FormEvent) => {
        e.preventDefault();

        setDataState('Create');
        setShowSubContactModal(true);

        // Clear form field data
        clearContactInput();
    };

    const handleCreateSubContact = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsContactData()) {
            setLoading(true);
            const data = await subContactDataAPI(professional?.contactId || 0, "Sub Employee", firstName, lastName, email, primaryPhone, secondaryPhone, Number(role.id), displayRoleName, profileImageFile!, localStorage.getItem('token') || '');
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorSubContact(key, value[0])
                    ))
                }
            } else {
                dispatch(fetchAllContactAfterEditProfessionalDetails());
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Sub contact created successfully.',
                        life: 3000
                    });
                }
                setShowSubContactModal(false);

                goToTop();
            }
        } else {
        }

    };

    /* *********************************************  For new Sub Contact create - end  ************************************************************ */
    /* **************************************************** Sub contact ******************************************************************* */
    /* **************************************************** Contact update - end *********************************************************** */

    /* **************************** role data get *************************** */
    const roleDataGet = async () => {
        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(data.data || []);
        }
    }
    /* **************************** role data get *************************** */

    /* **************************** Role name create - start *************************** */
    const handleSaveRoleName = async (e: React.FormEvent) => {
        e.preventDefault();

        setErrorRoleName('');
        if (checkCredentialsRoleCreate()) {

            const data = await roleCreateAPI(roleName, localStorage.getItem('token') || '');

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        setErrorRoleName(value[0])
                    ))
                }
            } else {
                /* clear data */
                setRoleName('');
                setShowAddData(false);
                /* call call data function */
                roleDataGet();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role created successfully.',
                        life: 3000
                    });
                }
            }
        }
    }

    function checkCredentialsRoleCreate(): boolean {
        const isRoleNameValid = checkText(roleName, true, setErrorRoleName);

        return isRoleNameValid;
    }
    /* **************************** Role name create - end *************************** */

    /* *****************************************************  For Update Company Details - start  ****************************************************** */
    const handleUpdateCompanyDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();
        if (checkCredentialsCompanyData()) {
            setLoading(true);
            const data = await employeeCompanyUpdateAPI(professional?.company_info_id || 0, "", "", companyName, companyRegNo, companyEmail, companyMobile, companyAddress, companyCity, companyPostCode, companyLandline);
            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorComapanyData(key, value[0])
                    ))
                }
            } else {
                dispatch(fetchAllContactAfterEditProfessionalDetails());

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Company details updated successfully.',
                        life: 3000
                    });
                }
                setShowEditModal(false);
                goToTop();
            }
        } else {
        }
    }

    function checkCredentialsCompanyData(): boolean {
        const isCompanyNameValid = checkText(companyName, true, setErrorCompanyName);
        const isCompanyEmailValid = checkEmail(companyEmail, true, setErrorCompanyEmail);
        const isCompanyMobileValid = checkMobileNumber(companyMobile, true, setErrorCompanyMobile);
        const isCompanyLandlineValid = checkPhoneNumber(companyLandline, false, setErrorCompanyLandline);
        const isCompanyAddressValid = checkText(companyAddress, true, setErrorCompanyAddress);
        const isCompanyCityValid = checkText(companyCity, true, setErrorCompanyCity);
        const isCompanyPostCodeValid = checkText(companyPostCode, true, setErrorCompanyPostCode);

        return isCompanyNameValid && isCompanyEmailValid && isCompanyMobileValid && isCompanyLandlineValid && isCompanyAddressValid && isCompanyCityValid && isCompanyPostCodeValid;
    }
    /* *****************************************************  For Update Company Details - end  ****************************************************** */

    /* ********************************  for Delete contact  ******************************** */
    const handleDeleteContact = async (e: React.FormEvent) => {
        confirmDialog({
            message: 'Are you sure you want to delete the company employee details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: deleteContact,
        });
    };

    const deleteContact = async () => {
        const res = await contactDeleteAPI(professional!.contactId);

        if (res.status) {
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Data deleted successfully.',
                    life: 3000
                });
            }
            setShowEditModal(false);

            setTimeout(() => {
                navigate('/contact');
            }, 500);

        } else {
            if (res.statusCode === 422) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Data deleted failed.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ********************************  for Delete contact  ******************************** */

    /********************************  For Role  ********************************/
    // For showing selected role
    const selectedRoleTemplate = (option: Role, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    <div>{option.role_name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    // For showing role options in the dropdown list
    const roleOptionTemplate = (option: Role) => {
        return (
            <div className="d-flex align-items-center">
                <div>{option.role_name}</div>
            </div>
        );
    };
    /**********************************************************************************************/


    const switchTabs = (tab: 'company' | 'contact' | 'sub_contact') => {
        setTab(tab);
        goToTop();
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    }

    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    useEffect(() => {
        roleDataGet();

        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);

    useEffect(() => {
        if (professional) {
            setCompanyName(professional.company_name);
            setCompanyEmail(professional.company_email);
            setCompanyRegNo(professional.company_regno);
            setCompanyMobile(professional.company_phone);
            setCompanyLandline(professional.company_landline);
            setCompanyAddress(professional.company_address);
            setCompanyCity(professional.company_city);
            setCompanyPostCode(professional.company_post_code);

            /* set main contact data */
            setMainContact(professional.subContact[0]);

            /* set sub contact data */
            const subContact = professional.subContact.filter((contact) => contact.employee_type === "Sub Employee");
            setSubContactList(subContact);

            /* have sub contact - show one contact */
            if (subContact[0]) {
                setShowOneSubContact(subContact[0]);
            }
        }
    }, [professional]);

    useEffect(() => {
        if (mainContact && mainContact?.profile_image) {
            const fileName = mainContact?.profile_image.split('/').pop();

            if (fileName === 'user.png') {
                setIsMainDefaultProfileImage(true);
            } else {
                setIsMainDefaultProfileImage(false);
            }
        } else {
            setIsMainDefaultProfileImage(false);
        }

        if (showOneSubContact && showOneSubContact?.profile_image) {
            const fileName = showOneSubContact?.profile_image.split('/').pop();

            if (fileName === 'user.png') {
                setIsSubDefaultProfileImage(true);
            } else {
                setIsSubDefaultProfileImage(false);
            }
        } else {
            setIsSubDefaultProfileImage(false);
        }
    }, [mainContact, showOneSubContact]);

    const breakpoints = {
        320: {
            slidesPerView: 1,
            spaceBetween: 8,
        },
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        991: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 2,
        },
        1400: {
            slidesPerView: 3,
        }
    };

    /* Sub contact modal component */
    const subContactModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5" id="subContactModalLabel">
                {dataState === 'Create' ? (
                    <span>Add sub contact</span>
                ) : dataState === 'Edit' ? (
                    <span>Edit sub contact</span>
                ) : null
                }
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={() => setShowSubContactModal(false)}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const subContactModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={() => setShowSubContactModal(false)} />
            {dataState === 'Create' ? (
                <Button label={`${loading ? 'Processing' : 'Save'}`} onClick={handleCreateSubContact} loading={loading} className="custom_btn primary" />
            ) : dataState === 'Edit' ? (
                <Button label={`${loading ? 'Processing' : 'Update'}`} onClick={handleUpdateSubContact} loading={loading} className="custom_btn primary" />
            ) : null}
        </div>
    );
    /* */

    /* Edit modal component */
    const editModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {tab === 'company' ?
                    "Edit Company detail" :
                    tab === 'contact' ?
                        "Edit Contact detail" :
                        tab === 'sub_contact' ?
                            "Edit Sub contact detail" :
                            null
                }
            </h5>
            {isPermissionDelete && (
                <button type="button" className="data_delete_btn p-ripple"
                    onClick={handleDeleteContact}>
                    <i className="bi bi-trash3"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    const editModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={() => setShowEditModal(false)} />
            {tab === 'company' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateCompanyDetails} loading={loading} className="custom_btn primary" />
            ) : tab === 'contact' ? (
                <Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateMainContact} loading={loading} className="custom_btn primary" />
            ) : null
            }
        </div>
    );

    const handleUseThisExistingCompanyDetails = (companyInterface: CompanyInterface | null) => {
        if (companyInterface != null) {
            setCompanyName(companyInterface.company_name);
            setCompanyRegNo(companyInterface.company_regno);
            setCompanyEmail(companyInterface.company_email);
            setCompanyMobile(companyInterface.company_phone);
            setCompanyAddress(companyInterface.company_address);
            setCompanyCity(companyInterface.city);
            setCompanyPostCode(companyInterface.post_code);
        }



    }

    const handleUseThisCompanyDetails = (companyInterface: CompanyInterface | null) => {
        if (companyInterface != null) {
            setCompanyName(companyInterface.company_name);
            setCompanyRegNo(companyInterface.company_regno);
            setCompanyEmail(companyInterface.company_email);
        }

        setCompanyMobile('');
        setCompanyAddress('');
        setCompanyCity('');
        setCompanyPostCode('');


    }

    const onEmailConfirmCompanyEmployee = (email: string) => {
        setEmail(email);
    }

    const onEmailConfirmCompanyEmployeeSubContract = (email: string) => {
        setEmail(email);
    }
    /* */


    /* Clear validation messages */
    // For Company employee
    // Company
    useEffect(() => {
        checkText(companyName, false, setErrorCompanyName);
    }, [companyName]);

    useEffect(() => {
        checkEmail(companyEmail, false, setErrorCompanyEmail);
    }, [companyEmail]);

    useEffect(() => {
        checkMobileNumber(companyMobile, false, setErrorCompanyMobile);
    }, [companyMobile]);

    useEffect(() => {
        checkPhoneNumber(companyLandline, false, setErrorCompanyLandline);
    }, [companyLandline]);

    useEffect(() => {
        checkText(companyAddress, false, setErrorCompanyAddress);
    }, [companyAddress]);

    useEffect(() => {
        checkText(companyCity, false, setErrorCompanyCity);
    }, [companyCity]);

    useEffect(() => {
        checkText(companyPostCode, false, setErrorCompanyPostCode);
    }, [companyPostCode]);
    // 

    // Contact
    useEffect(() => {
        checkText(firstName, false, setErrorFirstName);
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setErrorLastName);
    }, [lastName]);

    useEffect(() => {
        checkEmail(email, false, setErrorEmail);
    }, [email]);

    useEffect(() => {
        checkPhoneNumber(primaryPhone, false, setErrorPrimaryPhone);
    }, [primaryPhone]);

    useEffect(() => {
        checkPhoneNumber(secondaryPhone, false, setErrorSecondaryPhone);
    }, [secondaryPhone]);

    useEffect(() => {
        checkFileImage(profileImageFile!, false, setErrorProfileImageFile);
    }, [profileImageFile]);
    // 

    // Role
    useEffect(() => {
        checkRole(role, false, setErrorRoleId);
    }, [role]);

    useEffect(() => {
        checkText(displayRoleName, false, setErrorDisplayRoleName);
    }, [displayRoleName]);
    //
    /*  */


    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {(!professional) ? (
                    <ErrorPage
                        errorMessage="There was an error retrieving the selected employee details."
                    />
                ) : (
                    <React.Fragment>
                        <div className="main_head_area">
                            <h4 className="main_heading">View Contact</h4>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_label_area">
                            <h6>Company Employee</h6>

                            {tab === 'sub_contact' && (
                                <div className="page_action_area">
                                    {/* Edit button */}
                                    {isPermissionUpdate && (
                                        <button className="profile_edit_btn p-ripple" onClick={() => setShowEditModal(true)}>
                                            <i className="bi bi-pencil-square"></i>
                                            <Ripple />
                                        </button>
                                    )}

                                    {isPermissionAdd && (
                                        <button className="add_data_link_btn p-ripple" onClick={addSubContact}>
                                            <i className="bi bi-plus-circle"></i>
                                            <span>Add sub contact</span>
                                            <Ripple />
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="page_content mt-0">
                            <div className="page_body_area mt-3">
                                <div className="row">
                                    <div className="col-12 col-xl-4 mx-auto page_divider custom_height" style={{ minHeight }}>
                                        <div className="profile_view_area mt-2 mt-sm-0 mb-4 mb-sm-0">
                                            <div className="profile_view_main_area">
                                                <Image
                                                    className="profile_img_area"
                                                    src={mainContact?.profile_image ?? ''}
                                                    alt="Profile"
                                                    preview={!isMainDefaultProfileImage}
                                                />

                                                <h5 className="profile_name text_purple">
                                                    {(mainContact?.first_name || mainContact?.last_name)
                                                        ? `${mainContact?.first_name ?? ''} ${mainContact?.last_name ?? ''}`.trim()
                                                        : ''
                                                    }
                                                </h5>
                                                <h6 className="profile_role">{mainContact?.role_name}</h6>
                                            </div>

                                            <div className="profile_view_tab_area">
                                                <div className="profile_view_tabs" id="profileViewTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'company' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('company')}
                                                        id="company-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#company-detail" type="button"
                                                        role="tab"
                                                        aria-controls="company-detail"
                                                        aria-selected={tab === 'company'}
                                                    >
                                                        Company
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'contact' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('contact')}
                                                        id="contact-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#contact-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="contact-detail"
                                                        aria-selected={tab === 'contact'}
                                                    >
                                                        Contact
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'sub_contact' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('sub_contact')}
                                                        id="sub-contact-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#sub-contact-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="sub-contact-detail"
                                                        aria-selected={tab === 'sub_contact'}
                                                    >
                                                        Sub Contact
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_view_area">
                                            {/* Edit button */}
                                            {tab === 'company' && isPermissionUpdate && (
                                                <button className="profile_edit_btn main p-ripple" onClick={() => setShowEditModal(true)}>
                                                    <i className="bi bi-pencil-square"></i>
                                                    <Ripple />
                                                </button>
                                            )}

                                            <div className="tab-content profile_view_tab_content" id="profileViewTabContent">
                                                {/* Company Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'company' ? 'show active' : ''}`} id="company-detail" role="tabpanel" aria-labelledby="company-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Company name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company name</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_name ? (
                                                                        <p>{professional.company_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Reg no. */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Reg no.</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_regno ? (
                                                                        <p>{professional.company_regno}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Reg no.</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Company email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company email</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_email ? (
                                                                        <Link
                                                                            to={`mailto:${professional?.company_email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail">
                                                                            {professional.company_email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company phone no.</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_phone ? (
                                                                        <Link
                                                                            to={`tel:${professional.company_phone}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {professional.company_phone}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company phone no.</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Landline</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_landline ? (
                                                                        <Link
                                                                            to={`tel:${professional.company_landline}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {professional.company_landline}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Landline</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Company address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Company address</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_address ? (
                                                                        <p>{professional.company_address}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Company address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_city ? (
                                                                        <p>{professional.company_city}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {professional.company_post_code ? (
                                                                        <p>{professional.company_post_code}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Contact Details */}
                                                <div className={`tab-pane profile_view_tab_panel pt-4 pt-sm-2 fade ${tab === 'contact' ? 'show active' : ''}`} id="contact-detail" role="tabpanel" aria-labelledby="contact-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <article className="contact_view_container">
                                                                {/* Edit button */}
                                                                {isPermissionUpdate && <button className="profile_edit_btn main p-ripple" onClick={() => mainContactEdit()}>
                                                                    <i className="bi bi-pencil-square"></i>
                                                                    <Ripple />
                                                                </button>}

                                                                <div className="row">
                                                                    <div className="col-11 col-xl-9 col-xxl-8 col-lg-9 col-md-9 col-sm-10 mx-auto">
                                                                        <div className="contact_view_head_area">
                                                                            <Image
                                                                                className="profile_img_area"
                                                                                src={mainContact?.profile_image ?? ''}
                                                                                alt="Profile"
                                                                                preview={!isMainDefaultProfileImage}
                                                                            />

                                                                            <h5 className="profile_name text_purple">
                                                                                {(mainContact?.first_name || mainContact?.last_name)
                                                                                    ? `${mainContact?.first_name ?? ''} ${mainContact?.last_name ?? ''}`.trim()
                                                                                    : ''
                                                                                }
                                                                            </h5>
                                                                            <h6 className="profile_role">{mainContact?.role_name}</h6>
                                                                        </div>

                                                                        <hr className="mt-3 mb-3 mt-sm-4 mb-sm-4" />

                                                                        <div className="row">
                                                                            {professional.company_address && professional.company_post_code && professional.company_city &&
                                                                                <div className="col-12">
                                                                                    <div className="contact_view_item">
                                                                                        <i className="bi bi-geo-alt"></i>
                                                                                        <p>
                                                                                            {professional.company_address} <br />
                                                                                            {professional.company_post_code},&nbsp;
                                                                                            {professional.company_city} <br />
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            <div className="col-12 col-sm-6">
                                                                                <div className="contact_view_item">
                                                                                    <i className="bi bi-phone"></i>
                                                                                    {mainContact?.pimary_phone_no ? (
                                                                                        <Link
                                                                                            to={`tel:${mainContact?.pimary_phone_no}`}>
                                                                                            {mainContact?.pimary_phone_no}
                                                                                        </Link>
                                                                                    ) : (
                                                                                        <p className="text-secondary">---</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-12 col-sm-6">
                                                                                {mainContact?.secondary_phone_no &&
                                                                                    <div className="contact_view_item">
                                                                                        <i className="bi bi-telephone"></i>
                                                                                        {mainContact?.secondary_phone_no ? (
                                                                                            <Link
                                                                                                to={`tel:${mainContact?.secondary_phone_no}`}>
                                                                                                {mainContact?.secondary_phone_no}
                                                                                            </Link>
                                                                                        ) : (
                                                                                            <p className="text-secondary">---</p>
                                                                                        )}
                                                                                    </div>
                                                                                }
                                                                            </div>

                                                                            <div className="col-12">
                                                                                <div className="contact_view_item">
                                                                                    <i className="bi bi-envelope"></i>
                                                                                    {mainContact?.email ? (
                                                                                        <Link
                                                                                            to={`mailto:${mainContact?.email}`}>
                                                                                            {mainContact?.email}
                                                                                        </Link>
                                                                                    ) : (
                                                                                        <p className="text-secondary">---</p>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </article>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Sub Contact Details */}
                                                <div className={`tab-pane profile_view_tab_panel pt-4 pt-sm-0 fade ${tab === 'sub_contact' ? 'show active' : ''}`} id="sub-contact-detail" role="tabpanel" aria-labelledby="sub-contact-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {subContactList && subContactList?.length > 0 ? (
                                                            <div className="col-12">
                                                                <div className="contacts_view_slider_area">
                                                                    <Swiper
                                                                        className='hero-swiper-area'
                                                                        modules={[Navigation]}
                                                                        spaceBetween={10}
                                                                        slidesPerView={3}
                                                                        loop={false}
                                                                        breakpoints={breakpoints}
                                                                        navigation={{
                                                                            nextEl: '.next_tab_btn',
                                                                            prevEl: '.prev_tab_btn',
                                                                        }}
                                                                        grabCursor={true}
                                                                    >
                                                                        {subContactList && (
                                                                            <React.Fragment>
                                                                                {subContactList?.map((oneContact) => (
                                                                                    <SwiperSlide >
                                                                                        <button
                                                                                            className={`contact_slide_tab ${showOneSubContact?.id === oneContact.id ? 'active' : ''} p-ripple`}
                                                                                            onClick={() => handleSetSubcontactData(oneContact)}
                                                                                        >
                                                                                            <Image
                                                                                                className="contact_profile_img"
                                                                                                src={oneContact.profile_image ?? ''}
                                                                                                alt="Profile"
                                                                                            />

                                                                                            <div className="contact_slide_det">
                                                                                                <h6>{oneContact.first_name}</h6>
                                                                                                <p>{oneContact.role_name}</p>
                                                                                            </div>
                                                                                            <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                                                        </button>
                                                                                    </SwiperSlide>
                                                                                ))}
                                                                            </React.Fragment>
                                                                        )}
                                                                    </Swiper>

                                                                    <button className="tab_slide_btn prev_tab_btn p-ripple">
                                                                        <i className="ri-arrow-left-s-line"></i>
                                                                        <Ripple />
                                                                    </button>

                                                                    <button className="tab_slide_btn next_tab_btn p-ripple">
                                                                        <i className="ri-arrow-right-s-line"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                </div>

                                                                <article className="contact_view_container">
                                                                    {contentLoading ? (
                                                                        <div className="row">
                                                                            <div className="col-11 col-xl-9 col-xxl-8 col-lg-9 col-md-9 col-sm-10 mx-auto">
                                                                                <div className="contact_view_head_area">
                                                                                    <Skeleton shape="circle" className="profile_img_loader"></Skeleton>
                                                                                    <Skeleton width="8rem" className="mt-2"></Skeleton>
                                                                                    <Skeleton width="6rem" height="10px" className="mt-1"></Skeleton>
                                                                                </div>

                                                                                <hr className="mt-3 mb-3 mt-sm-4 mb-sm-4" />

                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        <div className="contact_view_item">
                                                                                            <Skeleton borderRadius="8px" size="1.8rem" className="mr-2"></Skeleton>
                                                                                            <div>
                                                                                                <Skeleton width="12rem" height="12px" className="mt-1"></Skeleton>
                                                                                                <Skeleton width="10rem" height="12px" className="mt-2"></Skeleton>
                                                                                                <Skeleton width="4rem" height="12px" className="mt-2"></Skeleton>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-12 col-sm-6">
                                                                                        <div className="contact_view_item">
                                                                                            <Skeleton borderRadius="8px" size="1.8rem" className="mr-2"></Skeleton>
                                                                                            <Skeleton width="8rem" height="12px" className="mt-2"></Skeleton>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-12 col-sm-6">
                                                                                        <div className="contact_view_item">
                                                                                            <Skeleton borderRadius="8px" size="1.8rem" className="mr-2"></Skeleton>
                                                                                            <Skeleton width="8rem" height="12px" className="mt-2"></Skeleton>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="col-12">
                                                                                        <div className="contact_view_item">
                                                                                            <Skeleton borderRadius="8px" size="1.8rem" className="mr-2"></Skeleton>
                                                                                            <Skeleton width="10rem" height="12px" className="mt-2"></Skeleton>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <React.Fragment>
                                                                            {showOneSubContact && (
                                                                                <div className="row">
                                                                                    <div className="col-11 col-xl-9 col-xxl-8 col-lg-9 col-md-9 col-sm-10 mx-auto">
                                                                                        <div className="contact_view_head_area">
                                                                                            <Image
                                                                                                className="profile_img_area"
                                                                                                src={showOneSubContact?.profile_image ?? ''}
                                                                                                alt="Profile"
                                                                                                preview={!isSubDefaultProfileImage}
                                                                                            />

                                                                                            <h5 className="profile_name text_purple">
                                                                                                {(showOneSubContact?.first_name || showOneSubContact?.last_name)
                                                                                                    ? `${showOneSubContact?.first_name ?? ''} ${showOneSubContact?.last_name ?? ''}`.trim()
                                                                                                    : ''
                                                                                                }
                                                                                            </h5>
                                                                                            <h6 className="profile_role">{showOneSubContact?.role_name}</h6>
                                                                                        </div>

                                                                                        <hr className="mt-3 mb-3 mt-sm-4 mb-sm-4" />

                                                                                        <div className="row">
                                                                                            {professional.company_address && professional.company_post_code && professional.company_city &&
                                                                                                <div className="col-12">
                                                                                                    <div className="contact_view_item">
                                                                                                        <i className="bi bi-geo-alt"></i>
                                                                                                        <p>
                                                                                                            {professional.company_address} <br />
                                                                                                            {professional.company_post_code},&nbsp;
                                                                                                            {professional.company_city} <br />
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            }
                                                                                            <div className="col-12 col-sm-6">
                                                                                                <div className="contact_view_item">
                                                                                                    <i className="bi bi-phone"></i>
                                                                                                    <Link to={`tel:${showOneSubContact?.pimary_phone_no}`}>{showOneSubContact?.pimary_phone_no}</Link>
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className="col-12 col-sm-6">
                                                                                                {showOneSubContact?.secondary_phone_no &&
                                                                                                    <div className="contact_view_item">
                                                                                                        <i className="bi bi-telephone"></i>
                                                                                                        <Link to={`tel:${showOneSubContact?.secondary_phone_no}`}>{showOneSubContact?.secondary_phone_no}</Link>
                                                                                                    </div>
                                                                                                }
                                                                                            </div>

                                                                                            <div className="col-12">
                                                                                                <div className="contact_view_item">
                                                                                                    <i className="bi bi-envelope"></i>
                                                                                                    <Link to={`mailto:${showOneSubContact?.email}`}>{showOneSubContact?.email}</Link>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </React.Fragment>
                                                                    )}
                                                                </article>
                                                            </div>
                                                        ) : (
                                                            <div className="col-12">
                                                                <div className="no_records_found custom mt-sm-2">
                                                                    <i className="bi bi-exclamation-circle me-1"></i>
                                                                    No sub-contacts found. Click the Add button to create.
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact edit modal */}
                        <Dialog header={editModalHeader} headerClassName="custom_modal_header"
                            footer={editModalFooter} visible={showEditModal}
                            className="custom_modal_dialog modal_dialog_lg" onHide={() => { if (!showEditModal) return; setShowEditModal(false); }}>
                            <div className="custom_modal_body">
                                <div className="row">
                                    <div className="col-12 col-xl-4 page_divider">
                                        <div className="profile_edit_area section_sticky">
                                            {tab === 'contact' ? (
                                                <React.Fragment>
                                                    <div className="form_img_upload_area pt-0">
                                                        <div className="form_img_upload">
                                                            <input
                                                                type="file"
                                                                accept={imageFileExtension}
                                                                className="form_img_upload_input"
                                                                id="profileImage"
                                                                onChange={handleImageChange}
                                                            />
                                                            <div className="form_img_upload_label_area">
                                                                <label
                                                                    htmlFor="profileImage"
                                                                    className={`form_img_upload_label ${profileImage ? 'uploaded' : ''}`}
                                                                    style={{ backgroundImage: profileImage ? `url(${profileImage})` : mainContact?.profile_image ? `url(${mainContact?.profile_image})` : '' }}
                                                                >
                                                                    {(!profileImage && mainContact?.profile_image === null) && (
                                                                        <div className="upload_icon">
                                                                            <i className="bi bi-camera-fill"></i>
                                                                        </div>
                                                                    )}
                                                                </label>

                                                                {(profileImage || mainContact?.profile_image) && (
                                                                    <label htmlFor="profileImage" className="upload_update_icon">
                                                                        <i className="bi bi-camera-fill"></i>
                                                                    </label>
                                                                )}
                                                            </div>
                                                            {profileImage ? (
                                                                <React.Fragment>
                                                                    <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                                    {profileImageFile && (
                                                                        <button className="upload_clear_button mt-2" onClick={clearImage}>Remove</button>
                                                                    )}
                                                                </React.Fragment>
                                                            ) : mainContact?.profile_image ? (
                                                                <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                            ) : (
                                                                <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {errorProfileImageFile &&
                                                        <small className="form_error_msg text-center mt-2">{errorProfileImageFile}</small>
                                                    }
                                                </React.Fragment>
                                            ) : (
                                                <div className="profile_view_main_area mb-4">
                                                    <Image
                                                        className="profile_img_area custom"
                                                        src={mainContact?.profile_image ?? ''}
                                                        alt="Profile"
                                                        preview={!isMainDefaultProfileImage}
                                                    />

                                                    <h5 className="profile_name text_purple">
                                                        {(mainContact?.first_name || mainContact?.last_name)
                                                            ? `${mainContact?.first_name ?? ''} ${mainContact?.last_name ?? ''}`.trim()
                                                            : ''
                                                        }
                                                    </h5>
                                                    <h6 className="profile_role">{mainContact?.role_name}</h6>
                                                </div>
                                            )}

                                            <div className="profile_edit_tab_area">
                                                <div className="profile_view_tabs" id="profileEditTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'company' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('company')}
                                                        id="company-edit-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#company-edit-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="company-edit-detail"
                                                        aria-selected={tab === 'company'}
                                                    >
                                                        Company
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'contact' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('contact')}
                                                        id="contact-edit-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#contact-edit-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="contact-edit-detail"
                                                        aria-selected={tab === 'contact'}
                                                    >
                                                        Contact
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'sub_contact' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('sub_contact')}
                                                        id="sub-contact-edit-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#sub-contact-edit-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="sub-contact-edit-detail"
                                                        aria-selected={tab === 'sub_contact'}
                                                    >
                                                        Sub Contact
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_edit_area edit_form h-100">
                                            <div className="tab-content profile_view_tab_content" id="profileEditTabContent">
                                                {/* Edit Company detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'company' ? 'show active' : ''}`}
                                                    id="company-edit-detail" role="tabpanel" aria-labelledby="company-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        <div className="col-12 col-xl-12 col-sm-12">
                                                            <div className="page_form_group">
                                                                <Button
                                                                    label="Find company"
                                                                    onClick={() => setShowSearchCompanyDetailsModal(true)}
                                                                    icon="bi bi-search"
                                                                    outlined
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Company name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyName" className="custom_form_label is_required">Company name</label>
                                                                <InputText
                                                                    id="companyName"
                                                                    value={companyName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company name"
                                                                />

                                                                {errorCompanyName &&
                                                                    <small className="form_error_msg">{errorCompanyName}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Reg No */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="lastName" className="custom_form_label">Reg No</label>
                                                                <InputText
                                                                    id="lastName"
                                                                    value={companyRegNo}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyRegNo(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Reg No"
                                                                />

                                                                {errorCompanyRegNo &&
                                                                    <small className="form_error_msg">{errorCompanyRegNo}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Company email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyEmail" className="custom_form_label is_required">Company email</label>
                                                                <InputText
                                                                    id="companyEmail"
                                                                    value={companyEmail}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company email"
                                                                />

                                                                {errorCompanyEmail &&
                                                                    <small className="form_error_msg">{errorCompanyEmail}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Company phone no. */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyMobile" className="custom_form_label is_required">Company phone no.</label>
                                                                <InputText
                                                                    id="companyMobile"
                                                                    value={companyMobile}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyMobile(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company phone no."
                                                                />

                                                                {errorCompanyMobile &&
                                                                    <small className="form_error_msg">{errorCompanyMobile}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyLandline" className="custom_form_label">Landline</label>
                                                                <InputText
                                                                    id="companyLandline"
                                                                    value={companyLandline}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyLandline(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Landline"
                                                                />

                                                                {errorCompanyLandline &&
                                                                    <small className="form_error_msg">{errorCompanyLandline}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Company address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyAddress" className="custom_form_label is_required">Company address</label>
                                                                <InputText
                                                                    id="companyAddress"
                                                                    value={companyAddress}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyAddress(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Company address"
                                                                />

                                                                {errorCompanyAddress &&
                                                                    <small className="form_error_msg">{errorCompanyAddress}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyCity" className="custom_form_label is_required">City</label>
                                                                <InputText
                                                                    id="companyCity"
                                                                    value={companyCity}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyCity(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="City"
                                                                />

                                                                {errorCompanyCity &&
                                                                    <small className="form_error_msg">{errorCompanyCity}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="companyPostCode" className="custom_form_label is_required">Post code</label>
                                                                <InputText
                                                                    id="companyPostCode"
                                                                    value={companyPostCode}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyPostCode(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Post code"
                                                                />

                                                                {errorCompanyPostCode &&
                                                                    <small className="form_error_msg">{errorCompanyPostCode}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Edit Contact detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'contact' ? 'show active' : ''}`}
                                                    id="contact-edit-detail" role="tabpanel" aria-labelledby="contact-edit-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* First name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                                <InputText
                                                                    id="firstName"
                                                                    value={firstName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="First name"
                                                                />



                                                                {errorFirstName &&
                                                                    <small className="form_error_msg">{errorFirstName}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Last name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="lastName" className="custom_form_label is_required">Last name</label>
                                                                <InputText
                                                                    id="lastName"
                                                                    value={lastName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Last name"
                                                                />

                                                                {errorLastName &&
                                                                    <small className="form_error_msg">{errorLastName}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                                <div className="input_search_group">
                                                                    <InputText
                                                                        id="email"
                                                                        value={email}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                        className="custom_form_input"
                                                                        placeholder="Email"
                                                                        disabled
                                                                    />

                                                                    {!email ? (
                                                                        <button
                                                                            className="input_grp_btn primary pos_abs p-ripple"
                                                                            onClick={() => setShowSearchComEmpEmailModal(true)}>
                                                                            <i className="bi bi-search"></i>
                                                                            <Ripple />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="input_grp_btn danger pos_abs p-ripple"
                                                                            onClick={() => setEmail('')}>
                                                                            <i className="bi bi-x-lg"></i>
                                                                            <Ripple />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                                {errorEmail &&
                                                                    <small className="form_error_msg">{errorEmail}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Primary phone no */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="primaryPhone" className="custom_form_label is_required">Primary phone no.</label>
                                                                <InputText
                                                                    id="primaryPhone"
                                                                    value={primaryPhone}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPrimaryPhone(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Primary phone no."
                                                                />

                                                                {errorPrimaryPhone &&
                                                                    <small className="form_error_msg">{errorPrimaryPhone}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Secondary phone no */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="primaryPhone" className="custom_form_label">Secondary phone no.</label>
                                                                <InputText
                                                                    id="primaryPhone"
                                                                    value={secondaryPhone}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSecondaryPhone(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Secondary phone no."
                                                                />

                                                                {errorSecondaryPhone &&
                                                                    <small className="form_error_msg">{errorSecondaryPhone}</small>
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <div className="w-100">
                                                                    <label htmlFor="role" className="custom_form_label is_required">Role name</label>
                                                                    <Dropdown value={role} id="role" onChange={(e: DropdownChangeEvent) => setRole(e.value)}
                                                                        options={roleList} optionLabel="role_name" valueTemplate={selectedRoleTemplate} itemTemplate={roleOptionTemplate}
                                                                        placeholder="Select role" className="form_dropdown w-100" showClear />

                                                                    {errorRoleId &&
                                                                        <small className="form_error_msg">{errorRoleId}</small>
                                                                    }
                                                                </div>

                                                                <div className="add_data_area">
                                                                    {isPermissionAdd && <button className={`add_data_btn ${showAddData ? 'danger' : ''} p-ripple`} onClick={toggleAddData}>
                                                                        <i className={`bi ${showAddData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                                        {showAddData ? (<span>Cancel</span>)
                                                                            : (<span>Add role</span>)
                                                                        }
                                                                        < Ripple />
                                                                    </button>}

                                                                    <div className={`add_data_input_area ${showAddData ? 'show' : ''}`}>
                                                                        <InputText
                                                                            id="roleName"
                                                                            value={roleName}
                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRoleName(e.target.value)}
                                                                            className="custom_form_input"
                                                                            placeholder="Enter role name"
                                                                        />

                                                                        <Button
                                                                            label="Add"
                                                                            className="ps-4 pe-4"
                                                                            onClick={handleSaveRoleName}
                                                                        />
                                                                    </div>
                                                                    {errorRoleName &&
                                                                        <small className="form_error_msg">{errorRoleName}</small>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Display role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label htmlFor="displayRoleName" className="custom_form_label is_required">Display role name</label>
                                                                <InputText
                                                                    id="displayRoleName"
                                                                    value={displayRoleName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Display role name"
                                                                />

                                                                {errorDisplayRoleName &&
                                                                    <small className="form_error_msg">{errorDisplayRoleName}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Edit Sub contact detail */}
                                                <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'sub_contact' ? 'show active' : ''}`}
                                                    id="sub-contact-edit-detail" role="tabpanel" aria-labelledby="sub-contact-edit-detail-tab" tabIndex={0}>
                                                    <div className="sub_contact_list_area">
                                                        <div className="row">

                                                            {/* Sub contacts */}
                                                            {subContactList && subContactList?.length > 0 ? (
                                                                <div className="col-12">
                                                                    <div className="page_label_area mb-3 mt-0">
                                                                        <h6>Sub contacts</h6>

                                                                        <button className={`add_data_btn p-ripple`} onClick={addSubContact}>
                                                                            <i className={`bi bi-plus-circle`}></i>
                                                                            Add sub contact
                                                                            < Ripple />
                                                                        </button>
                                                                    </div>

                                                                    {subContactList && (
                                                                        <React.Fragment>
                                                                            {subContactList?.map((oneContact) => {
                                                                                let isDefaultImage = false;

                                                                                if (oneContact && oneContact?.profile_image) {
                                                                                    const fileName = oneContact?.profile_image.split('/').pop();
                                                                                    if (fileName === 'user.png') {
                                                                                        isDefaultImage = true;
                                                                                    } else {
                                                                                        isDefaultImage = false;
                                                                                    }
                                                                                } else {
                                                                                    isDefaultImage = false;
                                                                                }

                                                                                return (
                                                                                    <article key={oneContact?.id} className="sub_contact_list">
                                                                                        <div className="sub_contact_list_detail_area">
                                                                                            <Image
                                                                                                className="sub_contact_profile_img"
                                                                                                src={oneContact.profile_image ?? ''}
                                                                                                alt="Profile"
                                                                                                preview={!isDefaultImage}
                                                                                            />
                                                                                            <div className="sub_contact_list_detail">
                                                                                                <h6 className="text_purple text_bold">
                                                                                                    {(oneContact?.first_name || oneContact?.last_name)
                                                                                                        ? `${oneContact?.first_name ?? ''} ${oneContact?.last_name ?? ''}`.trim()
                                                                                                        : ''
                                                                                                    }
                                                                                                </h6>
                                                                                                <p>{oneContact.role_name}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="sub_contact_list_action">
                                                                                            {isPermissionUpdate && (
                                                                                                <button className="data_action_btn primary p-ripple" onClick={() => handleEditSubContact(oneContact)}>
                                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                                    <Ripple />
                                                                                                </button>
                                                                                            )}

                                                                                            {isPermissionDelete && (
                                                                                                <button className="data_action_btn danger p-ripple"
                                                                                                    onClick={() => handleDeleteSubContact(oneContact.id)}>
                                                                                                    <i className="bi bi-trash3"></i>
                                                                                                    <Ripple />
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    </article>
                                                                                )
                                                                            })}
                                                                        </React.Fragment>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="col-12">
                                                                    <div className="no_records_found custom mt-sm-2 flex-column row-gap-3">
                                                                        <span>
                                                                            <i className="bi bi-exclamation-circle me-1"></i>
                                                                            No sub-contacts found. Click the Add button to create.
                                                                        </span>

                                                                        <button className={`add_data_btn p-ripple`} onClick={addSubContact}>
                                                                            <i className={`bi bi-plus-circle`}></i>
                                                                            Add sub contact
                                                                            < Ripple />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {/*  */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>
                        {/*  */}

                        {/* Sub Contact modal */}
                        <Dialog header={subContactModalHeader} headerClassName="custom_modal_header"
                            footer={subContactModalFooter} visible={showSubContactModal}
                            className="custom_modal_dialog modal_dialog_lg" onHide={() => { if (!showSubContactModal) return; setShowSubContactModal(false); }}>
                            <div className="custom_modal_body">
                                <div className="row">
                                    <div className="col-12 col-xl-3 mx-auto page_divider">
                                        <div className="form_left_area">
                                            {/* Profile image */}
                                            <div className="form_img_upload_area">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept={imageFileExtension}
                                                        className="form_img_upload_input"
                                                        id="profileImage"
                                                        onChange={handleImageChange}
                                                    />
                                                    <label
                                                        htmlFor="profileImage"
                                                        className="form_img_upload_label"
                                                        style={{ backgroundImage: profileImage ? `url(${profileImage})` : `` }}
                                                    >
                                                        {!profileImage && (
                                                            <div className="upload_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </div>
                                                        )}
                                                    </label>
                                                    {profileImage ? (
                                                        <React.Fragment>
                                                            <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                            {profileImageFile && (
                                                                <button className="upload_clear_button mt-2" onClick={clearImage}>Remove</button>
                                                            )}
                                                        </React.Fragment>
                                                    ) : (
                                                        <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>
                                            {errorProfileImageFile &&
                                                <small className="form_error_msg text-center mt-2">{errorProfileImageFile}</small>
                                            }
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-9 mx-auto">
                                        <div className="form_right_area">
                                            <div className="page_data_form_area">
                                                <div className="row">
                                                    {/* First name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="firstName" className="custom_form_label is_required">First name</label>
                                                            <InputText
                                                                id="firstName"
                                                                value={firstName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="First name"
                                                            />

                                                            {errorFirstName &&
                                                                <small className="form_error_msg">{errorFirstName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Last name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="lastName" className="custom_form_label is_required">Last name</label>
                                                            <InputText
                                                                id="lastName"
                                                                value={lastName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Last name"
                                                            />

                                                            {errorLastName &&
                                                                <small className="form_error_msg">{errorLastName}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                            <div className="input_search_group">
                                                                <InputText
                                                                    id="email"
                                                                    value={email}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Email"
                                                                    disabled
                                                                />

                                                                {!email ? (
                                                                    <button
                                                                        className="input_grp_btn primary pos_abs p-ripple"
                                                                        onClick={() => setShowSearchSubContractComEmpEmailModal(true)}>
                                                                        <i className="bi bi-search"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="input_grp_btn danger pos_abs p-ripple"
                                                                        onClick={() => setEmail('')}>
                                                                        <i className="bi bi-x-lg"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {errorEmail &&
                                                                <small className="form_error_msg">{errorEmail}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Primary phone no. */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="primaryPhone" className="custom_form_label is_required">Primary phone no.</label>
                                                            <InputText
                                                                id="primaryPhone"
                                                                value={primaryPhone}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPrimaryPhone(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Primary phone no."
                                                            />

                                                            {errorPrimaryPhone &&
                                                                <small className="form_error_msg">{errorPrimaryPhone}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Secondary phone no. */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="secondaryPhone" className="custom_form_label">Secondary phone no.</label>
                                                            <InputText
                                                                id="secondaryPhone"
                                                                value={secondaryPhone}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSecondaryPhone(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Secondary phone no."
                                                            />

                                                            {errorSecondaryPhone &&
                                                                <small className="form_error_msg">{errorSecondaryPhone}</small>
                                                            }
                                                        </div>
                                                    </div>

                                                    {/* Role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <div className="w-100">
                                                                <label htmlFor="role" className="custom_form_label is_required">Role name</label>
                                                                <Dropdown value={role} id="role" onChange={(e: DropdownChangeEvent) => setRole(e.value)}
                                                                    options={roleList} optionLabel="role_name" valueTemplate={selectedRoleTemplate} itemTemplate={roleOptionTemplate}
                                                                    placeholder="Select role" className="form_dropdown w-100" showClear />

                                                                {errorRoleId &&
                                                                    <small className="form_error_msg">{errorRoleId}</small>
                                                                }
                                                            </div>

                                                            <div className="add_data_area">
                                                                {isPermissionAdd && (
                                                                    <button className={`add_data_btn ${showAddData ? 'danger' : ''} p-ripple`} onClick={toggleAddData}>
                                                                        <i className={`bi ${showAddData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                                        {showAddData ? (<span>Cancel</span>)
                                                                            : (<span>Add role</span>)
                                                                        }
                                                                        < Ripple />
                                                                    </button>
                                                                )}

                                                                <div className={`add_data_input_area ${showAddData ? 'show' : ''}`}>
                                                                    <InputText
                                                                        id="roleName"
                                                                        value={roleName}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setRoleName(e.target.value)}
                                                                        className="custom_form_input"
                                                                        placeholder="Enter role name"
                                                                    />

                                                                    <Button
                                                                        label="Add"
                                                                        className="ps-4 pe-4"
                                                                        onClick={handleSaveRoleName}
                                                                    />
                                                                </div>
                                                                {errorRoleName &&
                                                                    <small className="form_error_msg">{errorRoleName}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Display role name */}
                                                    <div className="col-12 col-xl-6 col-sm-6">
                                                        <div className="page_form_group">
                                                            <label htmlFor="displayRoleName" className="custom_form_label is_required">Display role name</label>
                                                            <InputText
                                                                id="displayRoleName"
                                                                value={displayRoleName}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Display role name"
                                                            />

                                                            {errorDisplayRoleName &&
                                                                <small className="form_error_msg">{errorDisplayRoleName}</small>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        <CompanySearchDialog
                            visible={showSearchCompanyDetailsModal}
                            onHide={() => setShowSearchCompanyDetailsModal(false)}
                            onExistingCompanyDetailsConfirm={(company) => handleUseThisExistingCompanyDetails(company)}
                            onCompanyDetailsConfirm={(company) => handleUseThisCompanyDetails(company)}
                        />

                        <EmailSearchDialog
                            visible={showSearchComEmpEmailModal}
                            contactSubtype="Company"
                            onHide={() => setShowSearchComEmpEmailModal(false)}
                            onEmailConfirm={(email) => onEmailConfirmCompanyEmployee(email)}
                        />

                        <EmailSearchDialog
                            visible={showSearchSubContractComEmpEmailModal}
                            contactSubtype="Company"
                            onHide={() => setShowSearchSubContractComEmpEmailModal(false)}
                            onEmailConfirm={(email) => onEmailConfirmCompanyEmployeeSubContract(email)}
                        />

                        {/*  */}
                    </React.Fragment >
                )}
            </div>
        </React.Fragment>
    )
}

export default ViewCompanyEmployeeContact;